"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitFrequencyMessage = void 0;
var util_1 = require("../../util");
var message_priority_interface_1 = require("./message-priority.interface");
/**
 *  限频的消息
 *
 * @class LimitFrequencyMessage
 */
var LimitFrequencyMessage = /** @class */ (function () {
    function LimitFrequencyMessage(type, priority, dependency) {
        this.type = type;
        this.priority = priority;
        this.dependency = dependency;
        // 当前限频时长
        this.duration = message_priority_interface_1.NOT_LIMIT_FREQUENCY;
        // 限频时长内缓存消息
        this.messages = [];
    }
    /**
     * 是否需要限频
     *
     * @param {string} type
     * @returns {boolean}
     */
    LimitFrequencyMessage.prototype.shouldLimit = function (type) {
        return this.type === type;
    };
    LimitFrequencyMessage.prototype.handleMessage = function (message, level, memberCount) {
        var _this = this;
        this.memberCount = memberCount;
        var duration = this.calculateLimitDuration(level);
        // 不限频
        if (duration === message_priority_interface_1.NOT_LIMIT_FREQUENCY) {
            if (duration !== this.duration) {
                this.transfer();
                this.reset();
            }
            return;
        }
        message.needDeal = false;
        if (duration === message_priority_interface_1.FOREVER_LIMIT_FREQUENCY) {
            this.duration = duration;
            // 如果是永久限频消息，直接丢～
            return;
        }
        // 缓存消息
        this.pushMessage(message);
        // 缓存间隔发生变化时重新开始计算延迟
        if (duration !== this.duration) {
            this.reset();
            this.duration = duration;
            this.transferTimer = setInterval(function () {
                _this.transfer();
            }, this.duration);
        }
    };
    LimitFrequencyMessage.prototype.pushMessage = function (message) {
        this.messages.push(message);
    };
    LimitFrequencyMessage.prototype.transfer = function () {
        if (!this.messages.length) {
            return;
        }
        util_1.ConnectionLog.info("transfer memberCount:" + this.memberCount + ", type:" + this.type + ", duration:" + this.duration);
        this.transferToBusiness(this.type, this.messages);
        // 清除已经分发给业务的消息缓存
        this.messages.splice(0, this.messages.length);
    };
    LimitFrequencyMessage.prototype.transferToBusiness = function (type, messages) {
        this.dependency.receiveMessageFromServer(type, messages);
    };
    LimitFrequencyMessage.prototype.reset = function () {
        // 清楚定时器
        clearInterval(this.transferTimer);
        this.transferTimer = 0;
        // 清除延迟间隔
        this.duration = message_priority_interface_1.NOT_LIMIT_FREQUENCY;
    };
    LimitFrequencyMessage.prototype.calculateLimitDuration = function (level) {
        try {
            // 目前默认高优先级，不限频
            if (this.priority === message_priority_interface_1.MessagePriority.HIGH) {
                return message_priority_interface_1.NOT_LIMIT_FREQUENCY;
            }
            return message_priority_interface_1.LIMIT_FREQUENCY_STRAGEGY[this.priority][level];
        }
        catch (error) {
            return message_priority_interface_1.NOT_LIMIT_FREQUENCY;
        }
    };
    return LimitFrequencyMessage;
}());
exports.LimitFrequencyMessage = LimitFrequencyMessage;
